var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPop2WinLeftDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.6,30H5.4V0h19.3V30z M6.3,29h17.3V1H6.3V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6,25.3H9.4V4.7h11.2V25.3z M10.3,24.4h9.3V5.6h-9.3V24.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1,
    y: 21.5,
    transform: "matrix(0.6898 -0.724 0.724 0.6898 -11.7785 16.5603)",
    width: 20.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -2.5,
    transform: "matrix(0.7011 -0.7131 0.7131 0.7011 -1.3383 11.8265)",
    width: 1,
    height: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4,
    cy: 14.5,
    rx: 2.2,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,29.6l-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6l0.4-1.6C6.3,27.1,6.6,27,6.8,27c0.3,0.1,0.4,0.3,0.3,0.6l-0.4,1.6 C6.7,29.4,6.5,29.6,6.3,29.6z M7.5,25.2l-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6l1-3.7c0.1-0.3,0.3-0.4,0.6-0.3C8.9,20.6,9,20.8,9,21.1 l-1,3.7C7.9,25.1,7.7,25.2,7.5,25.2z M9.3,18.7l-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6l1-3.7c0.1-0.3,0.3-0.4,0.6-0.3 c0.3,0.1,0.4,0.3,0.3,0.6l-1,3.7C9.7,18.5,9.5,18.7,9.3,18.7z M11.1,12.1l-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6l1-3.7 c0.1-0.3,0.3-0.4,0.6-0.3c0.3,0.1,0.4,0.3,0.3,0.6l-1,3.7C11.5,12,11.3,12.1,11.1,12.1z M12.9,5.6l-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6 l1-3.7C13.5,1,13.8,0.8,14,0.9c0.3,0.1,0.4,0.3,0.3,0.6l-1,3.7C13.3,5.5,13.1,5.6,12.9,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,29.6c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.6c-0.1-0.3,0-0.5,0.3-0.6c0.2-0.1,0.5,0,0.6,0.3l1.3,3.6c0.1,0.3,0,0.5-0.3,0.6 L24.2,29.6z M21.9,23.2c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.6c-0.1-0.3,0-0.5,0.3-0.6c0.2-0.1,0.5,0,0.6,0.3l1.3,3.6 c0.1,0.3,0,0.5-0.3,0.6L21.9,23.2z M19.6,16.8c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.6c-0.1-0.3,0-0.5,0.3-0.6c0.2-0.1,0.5,0,0.6,0.3 l1.3,3.6c0.1,0.3,0,0.5-0.3,0.6L19.6,16.8z M17.4,10.4c-0.2,0-0.4-0.1-0.5-0.3l-1.3-3.6c-0.1-0.3,0-0.5,0.3-0.6 c0.2-0.1,0.5,0,0.6,0.3l1.3,3.6c0.1,0.3,0,0.5-0.3,0.6L17.4,10.4z M15.1,4c-0.2,0-0.4-0.1-0.5-0.3l-0.8-2.2c-0.1-0.3,0-0.5,0.3-0.6 c0.2-0.1,0.5,0,0.6,0.3l0.8,2.2c0.1,0.3,0,0.5-0.3,0.6L15.1,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPop2WinLeftDoor);
export default __webpack_public_path__ + "static/media/pop_2win_left_door.8f8590bbaf4d6de650f93b6a2cf1a26d.svg";
export { ForwardRef as ReactComponent };